import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import SelectPlanIFrame from "../components/SelectPlan/SelectPlanIFrame";
import Loader from '../components/Loader';
import validateJwt from '../utils/ValidateJwt';
import { jwtDecode } from 'jwt-decode';
import Header from '../components/SelectPlan/Header';
import BackModal from '../components/SelectPlan/BackModal';
import { refreshToken } from '../api/identity/refreshToken';
import { getEVPlanDetails } from '../api/subscription/selectPlan';
import { sendAnalyticsEvent } from '../utils/SendAnalyticsEvent';

const SelectPlan = () => {
  const navigate = useNavigate();
  document.title = "iWantTFC - Discover | Select Plan";

  const [countryCode, setCountryCode] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [auc, setAuc] = useState('');
  const [signature, setSignature] = useState('');
  const [modalStatus, setModalStatus] = useState('');
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [loadPlanDetails, setloadPlanDetails] = useState(false);

  const updateModal = (status) => {
    setModalStatus(status);
  };

  const updateIframeStatus = (status) => {
    setIframeLoaded(status);
  };

  useEffect(() => {
    const _auc = Cookies.get('UserAuthentication');

    if (!_auc) {
      window.location.replace(process.env.REACT_APP_AUTH_LOGIN_URL + "?redirectUrl=" + encodeURIComponent(window.location.href));
    }

    let isSynacor = _auc?.indexOf("ffjwt-") >= 0;
    var jwt = jwtDecode(_auc.replace("ffjwt-", ""));
    if (isSynacor) {
      navigate('/cable-subscribed', { replace: true, state: { pm: jwt.provider } });
    } else {
      if (!validateJwt(_auc)) {
        if (localStorage && localStorage.getItem('refreshToken')) {
          const refReq = {
            token: localStorage.getItem('refreshToken'),
            country: jwt.cp?.replace("ABSCBN-", "")
          };
          const fetchData = async () => {
            const refRes = await refreshToken(refReq);
            if (refRes.isError) {
              window.location.replace(process.env.REACT_APP_AUTH_LOGOUT_URL + "?redirectUrl=" + encodeURIComponent(window.location.href));
            } else {
              if (refRes.data.accessToken) {
                setAuc(refRes.data.accessToken);
                setloadPlanDetails(true);
                Cookies.set("UserAuthentication", refRes.data.accessToken, { expires: 365, secure: true });
              } else {
                window.location.replace(process.env.REACT_APP_AUTH_LOGOUT_URL + "?redirectUrl=" + encodeURIComponent(window.location.href));
              }
            }
          }
          fetchData();
        } else {
          window.location.replace(process.env.REACT_APP_AUTH_LOGOUT_URL + "?redirectUrl=" + encodeURIComponent(window.location.href));
        }
      } else {
        setAuc(_auc);
        setloadPlanDetails(true);
      }
    };
  }, []);

  useEffect(() => {
    if (loadPlanDetails === true) {
      const fetchData = async () => {
        try {
          const formObj = {
            userDetails: auc,
            successCallbackUrl: process.env.REACT_APP_EV_SUCCESS_CALLBACK_URL,
            failureCallbackUrl: process.env.REACT_APP_EV_FAILURE_CALLBACK_URL,
            target: process.env.REACT_APP_EV_TARGET
          };
          const evRes = await getEVPlanDetails(formObj);
          if (!evRes.isError) {
            const webPm = process.env.REACT_APP_WEB_PAYMENT_METHODS;
            if (webPm.indexOf(evRes.paymentMethod?.toLowerCase()) >= 0 || evRes.planDescription?.toLowerCase().indexOf("free plan") >= 0) {
              var _countryCode = evRes.countryCode === undefined ? "undefined" : evRes.countryCode;
              var _stateCode = evRes.stateCode === undefined ? "undefined" : evRes.stateCode;
              var _zipCode = evRes.zipCode === undefined ? "undefined" : evRes.zipCode;
              setCountryCode(_countryCode);
              setStateCode(_stateCode);
              setZipCode(_zipCode);
              setSignature(evRes.signature);
              sendAnalyticsEvent("selectPlanPageRender", {}, "Purchase Journey", "Discover page");
            } else {
              navigate('/subscribed', { replace: true, state: { pm: evRes.paymentMethod } });
            }
          } else {
            throw new Error(evRes.message);
          }
        } catch (error) {
          navigate('/error', { replace: true, state: { message: error.message } });
        }
      }
      fetchData();
    }
  }, [loadPlanDetails, auc]);

  return (
    <div className="select-plan-container">
      {countryCode && signature && iframeLoaded && (
        <Header updateModal={updateModal} />
      )}
      {countryCode && signature && iframeLoaded && (
        <BackModal updateModal={updateModal} modalStatus={modalStatus} />
      )}
      {countryCode && signature && (
        <SelectPlanIFrame
          token={auc}
          countryCode={countryCode}
          stateCode={stateCode}
          zipCode={zipCode}
          signature={signature}
          setIframeStatus={updateIframeStatus}
        />
      )}
      <Loader />
    </div>
  );
}

export default SelectPlan;